export default __webpack_public_path__ + "static/media/cart-new.fc5736ac.svg";